const axios = {
	// GET request
	get(url, config = {}) {
		// apply request interceptors
		if (config.params) {
			url = new URL(url, window.location.origin);
			Object.entries(config.params).forEach(([key, value]) => {
				if(value !== undefined && value !== null) {
					url.searchParams.append(key, value);
				}
			});
		}
		let req = { url, config };
		axios.interceptors.request.handlers.forEach(
			({ onFulfilled, onRejected }) => {
				try {
					req = onFulfilled?.(req) || req;
				} catch (err) {
					onRejected && onRejected(err);
					throw err;
				}
			}
		);
		url = req.url;
		config = req.config;

		return fetch(url, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				...config.headers,
			},
			...config,
		})
			.then((response) => handleResponse(response))
			.then((resp) => {
				// run response interceptors
				axios.interceptors.response.handlers.forEach(
					({ onFulfilled, onRejected }) => {
						try {
							resp = onFulfilled?.(resp) || resp;
						} catch (err) {
							onRejected && onRejected(err);
							throw err;
						}
					}
				);
				return resp;
			});
	},

	// POST request
	post(url, data, config = {}) {
		// apply request interceptors
		let req = { url, config: { ...config, data } };
		axios.interceptors.request.handlers.forEach(
			({ onFulfilled, onRejected }) => {
				try {
					req = onFulfilled?.(req) || req;
				} catch (err) {
					onRejected && onRejected(err);
					throw err;
				}
			}
		);
		url = req.url;
		data = req.config.data;
		config = req.config;

		return fetch(url, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				...config.headers,
			},
			body: JSON.stringify(data),
			...config,
		})
			.then((response) => handleResponse(response))
			.then((resp) => {
				axios.interceptors.response.handlers.forEach(
					({ onFulfilled, onRejected }) => {
						try {
							resp = onFulfilled?.(resp) || resp;
						} catch (err) {
							onRejected && onRejected(err);
							throw err;
						}
					}
				);
				return resp;
			});
	},

	// PUT request
	put(url, data, config = {}) {
		// apply request interceptors
		let req = { url, config: { ...config, data } };
		axios.interceptors.request.handlers.forEach(
			({ onFulfilled, onRejected }) => {
				try {
					req = onFulfilled?.(req) || req;
				} catch (err) {
					onRejected && onRejected(err);
					throw err;
				}
			}
		);
		url = req.url;
		data = req.config.data;
		config = req.config;

		return fetch(url, {
			method: "PUT",
			headers: {
				"Content-Type": "application/json",
				...config.headers,
			},
			body: JSON.stringify(data),
			...config,
		})
			.then((response) => handleResponse(response))
			.then((resp) => {
				axios.interceptors.response.handlers.forEach(
					({ onFulfilled, onRejected }) => {
						try {
							resp = onFulfilled?.(resp) || resp;
						} catch (err) {
							onRejected && onRejected(err);
							throw err;
						}
					}
				);
				return resp;
			});
	},

	// DELETE request
	delete(url, config = {}) {
		// apply request interceptors
		let req = { url, config };
		axios.interceptors.request.handlers.forEach(
			({ onFulfilled, onRejected }) => {
				try {
					req = onFulfilled?.(req) || req;
				} catch (err) {
					onRejected && onRejected(err);
					throw err;
				}
			}
		);
		url = req.url;
		config = req.config;

		return fetch(url, {
			method: "DELETE",
			headers: {
				"Content-Type": "application/json",
				...config.headers,
			},
			...config,
		})
			.then((response) => handleResponse(response))
			.then((resp) => {
				axios.interceptors.response.handlers.forEach(
					({ onFulfilled, onRejected }) => {
						try {
							resp = onFulfilled?.(resp) || resp;
						} catch (err) {
							onRejected && onRejected(err);
							throw err;
						}
					}
				);
				return resp;
			});
	},

	// Generic request method for other HTTP methods
	request(config) {
		// apply request interceptors
		let req = { url: config.url, config };
		axios.interceptors.request.handlers.forEach(
			({ onFulfilled, onRejected }) => {
				try {
					req = onFulfilled?.(req) || req;
				} catch (err) {
					onRejected && onRejected(err);
					throw err;
				}
			}
		);
		config = req.config;

		return fetch(config.url, {
			method: config.method || "GET",
			headers: {
				"Content-Type": "application/json",
				...config.headers,
			},
			body: config.data ? JSON.stringify(config.data) : undefined,
			...config,
		})
			.then((response) => handleResponse(response))
			.then((resp) => {
				axios.interceptors.response.handlers.forEach(
					({ onFulfilled, onRejected }) => {
						try {
							resp = onFulfilled?.(resp) || resp;
						} catch (err) {
							onRejected && onRejected(err);
							throw err;
						}
					}
				);
				return resp;
			});
	},
};

// Helper function to handle response
function handleResponse(response) {
	if (!response.ok) {
		return response.json().then((err) => Promise.reject(err));
	}
	return response.json().then((data) => ({
		data,
		status: response.status,
		statusText: response.statusText,
		headers: response.headers,
	}));
}

// Optional: Add defaults like Axios
axios.defaults = {
	headers: {},
};

// add interceptors API
axios.interceptors = {
	request: {
		handlers: [],
		use(onFulfilled, onRejected) {
			this.handlers.push({ onFulfilled, onRejected });
		},
	},
	response: {
		handlers: [],
		use(onFulfilled, onRejected) {
			this.handlers.push({ onFulfilled, onRejected });
		},
	},
};

export default axios;
